import { DispatchChartInteractionType, DispatchChartInteractionUseCase, } from '@thoughtspot/ts-chart-sdk';
import Joi from 'joi';
import { pointSchema } from '../context-menu-events/util';
const pointerDownEventPayloadSchema = Joi.object({
    event: Joi.object({
        clientX: Joi.number().required(),
        clientY: Joi.number().required(),
    }).required(),
    targetId: Joi.string()
        .optional()
        .min(1),
    targetData: Joi.object().optional(),
});
const vizPointRightClickEventPayloadSchema = Joi.object({
    event: Joi.object({
        clientX: Joi.number().required(),
        clientY: Joi.number().required(),
    }).required(),
    clickedPoint: pointSchema.required(),
});
const vizPointClickEventPayloadSchema = Joi.object({
    event: Joi.object({
        clientX: Joi.number().required(),
        clientY: Joi.number().required(),
    }).required(),
    clickedPoint: pointSchema.required(),
});
const vizPointDoubleClickEventPayloadSchema = Joi.object({
    event: Joi.object({
        clientX: Joi.number().required(),
        clientY: Joi.number().required(),
    }).required(),
    clickedPoint: pointSchema.required(),
});
const dispatchChartInteractionSchema = Joi.object({
    type: Joi.string()
        .valid(...Object.values(DispatchChartInteractionType))
        .required(),
    useCases: Joi.array()
        .items(Joi.string().valid(...Object.values(DispatchChartInteractionUseCase)))
        .min(1)
        .required(),
    eventPayload: Joi.when('type', {
        switch: [
            {
                is: DispatchChartInteractionType.PointerDown,
                then: pointerDownEventPayloadSchema.required(),
            },
            {
                is: DispatchChartInteractionType.VizPointRightClick,
                then: vizPointRightClickEventPayloadSchema.required(),
            },
            {
                is: DispatchChartInteractionType.VizPointClick,
                then: vizPointClickEventPayloadSchema.required(),
            },
            {
                is: DispatchChartInteractionType.VizPointDoubleClick,
                then: vizPointDoubleClickEventPayloadSchema.required(),
            },
        ],
    }),
});
export const validateDispatchChartInteractionPayload = (payload) => {
    try {
        Joi.assert(payload, dispatchChartInteractionSchema);
    }
    catch (err) {
        throw new Error(err.details?.[0]?.message || 'Invalid payload');
    }
};
//# sourceMappingURL=utils.js.map